import React, { useEffect, useState } from "react";
import "./TrainerPlayer.scss";
import { useTranslation } from "react-i18next";
import { AspectRatio, Cards, nFormatter } from "../../../api/ReplayVariables";
import ChipsLabel from "../../../replayer/ChipsLabel";
import {
  getTrainerCard,
  hasPlayerFolded,
  getTrainerSeatName
} from "./TrainerVariables";
import { getRepositionedSeat } from "../../../api/ReplayPlayer";

function TrainerPlayer({
  position,
  hero,
  cardsSize,
  realTableRatio,
  imgPosition,
  zonePosition,
  data,
  match,
  placeAfterHero
}) {
  const [cards, setCards] = useState([0, 0]);
  const [folded, setFolded] = useState(false);
  const [seatName, setSeatName] = useState("");
  const [chipsOnTable, setChipsOnTable] = useState(0);
  const [stack, setStack] = useState(0);

  const { t } = useTranslation();

  useEffect(() => {
    //console.log("player position", position);
    if (hero) {
      let _chipsOnTable =
        data.trainerResult.heroPos === "SB"
          ? 0.5
          : data.trainerResult.heroPos === "BB"
          ? 1
          : 0;
      setChipsOnTable(_chipsOnTable);
      setStack(data.trainerResult.heroStack - _chipsOnTable);
      let hand = data.trainerResult.hand;
      let strCards = hand.substring(0, 2);
      let suited = hand.endsWith("s");
      let _cards = [];
      for (let i = 0; i < strCards.length; i++) {
        _cards.push(
          getTrainerCard(strCards.substring(i, i + 1), i + 1, suited)
        );
      }
      setCards(_cards);
      setFolded((f) => false);
    } else {
      let _chipsOnTable = seatName === "SB" ? 0.5 : seatName === "BB" ? 1 : 0;

      if (seatName === data.trainerResult.vilainPos) {
        _chipsOnTable = data.trainerResult.heroStack + 1;
        setStack(0);
        setFolded((f) => false);
      } else {
        setFolded((f) =>
          hasPlayerFolded(
            match.params.game,
            match.params.situation,
            data.trainerResult.heroPos,
            data.trainerResult.vilainPos,
            placeAfterHero
          )
        );
        let _stack = data.trainerResult.heroStack - _chipsOnTable;
        setStack(_stack);
      }
      setChipsOnTable(_chipsOnTable);
    }
    setSeatName(
      getTrainerSeatName(
        match.params.game,
        data.trainerResult.heroPos,
        placeAfterHero
      )
    );
    return () => {
      //console.log("trainerPlayer effect done", position);
    };
  }, [
    data.trainerResult.hand,
    data.trainerResult.heroPos,
    data.trainerResult.vilainPos,
    data.trainerResult.heroStack,
    hero,
    match.params.game,
    match.params.situation,
    placeAfterHero,
    seatName
  ]);
  return (
    <>
      {!folded ? (
        <ChipsLabel
          seats={data.trainerResult.player}
          player={{
            chipsOnTable: chipsOnTable
          }}
          seat={getRepositionedSeat(position.seat, data.trainerResult.player)}
          imgPosition={imgPosition}
          zonePosition={zonePosition}
          realTableRatio={realTableRatio}
          bbMode={true}
          bigBlind={1}
        ></ChipsLabel>
      ) : (
        <></>
      )}
      <table
        className={
          "trainer-player" + (folded ? " folded" : "") + (hero ? " hero" : "")
        }
        style={{ left: position.left + "px", top: position.top + "px" }}
      >
        <tbody>
          <tr>
            <td className="cards">
              <div className="d-flex justify-content-center">
                {cards.map((card, index) => (
                  <img
                    key={index}
                    className={
                      index < cards.length - 1 ? "cardQuarter" : "cardHalf"
                    }
                    src={
                      Cards[
                        (index < cards.length - 1
                          ? "cardQuarter"
                          : "cardHalf") + (hero ? card : "Unknown")
                      ]
                    }
                    style={{
                      width:
                        (index < cards.length - 1
                          ? cardsSize.quarterWidth
                          : cardsSize.width) + "px",
                      height: cardsSize.height + "px"
                    }}
                    alt=""
                  />
                ))}
              </div>
            </td>
          </tr>
          <tr>
            <td
              className="name"
              style={{
                width:
                  Math.round(AspectRatio.refPlayerWidth * realTableRatio) +
                  "px",
                fontSize:
                  Math.round(AspectRatio.refFontSize * realTableRatio * 1.2) +
                  "px",
                lineHeight:
                  Math.round(AspectRatio.refFontSize * realTableRatio * 2) +
                  "px"
              }}
            >
              <div>
                {hero
                  ? t("poktools.trainer.hero")
                  : t("poktools.trainer.vilain") + " " + placeAfterHero}
              </div>
            </td>
          </tr>
          <tr>
            <td
              className="position"
              style={{
                fontSize:
                  Math.round(AspectRatio.refFontSize * realTableRatio * 1) +
                  "px"
              }}
            >
              <div>
                {t(
                  "poktools.positions." +
                    (hero ? data.trainerResult.heroPos : seatName)
                )}
              </div>
            </td>
          </tr>
          <tr>
            <td
              className={"stack" + (stack === 0 ? " allin" : "")}
              style={{
                lineHeight:
                  Math.round(AspectRatio.refLineHeight * realTableRatio * 1.2) +
                  "px",
                fontSize:
                  Math.round(AspectRatio.refFontSize * realTableRatio * 1.4) +
                  "px"
              }}
            >
              <div>
                {folded
                  ? "FOLD"
                  : stack === 0
                  ? "ALL IN"
                  : nFormatter(stack) + " BB"}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </>
  );
}
export default TrainerPlayer;
